var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            model: _vm.form,
            "label-position": "right",
            "label-width": _vm.formLabelWidth,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "供应商名称/ID：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "供应商名称/ID" },
                model: {
                  value: _vm.form.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "keyword", $$v)
                  },
                  expression: "form.keyword",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "创建日期：" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.startEndDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startEndDate", $$v)
                  },
                  expression: "form.startEndDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "RESOURCE_SUPPLIER_ADD",
                      expression: "'RESOURCE_SUPPLIER_ADD'",
                    },
                  ],
                  attrs: { icon: "el-icon-plus" },
                  on: {
                    click: function ($event) {
                      return _vm.onAdd()
                    },
                  },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "RESOURCE_SUPPLIER_SEARCH",
                      expression: "'RESOURCE_SUPPLIER_SEARCH'",
                    },
                  ],
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("\n        搜索\n      ")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-delete" },
                  on: { click: _vm.onSubmitClear },
                },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "productType", label: "供应商 ID", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "供应商名称", width: "180" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bizType",
              label: "业务类型",
              formatter: _vm.formatBizType,
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "合作状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.status === 1 ? "合作中" : "终止合作") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "address", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "RESOURCE_SUPPLIER_EDIT",
                            expression: "'RESOURCE_SUPPLIER_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        nativeOn: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onAdd(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "RESOURCE_SUPPLIER_FONFIG",
                            expression: "'RESOURCE_SUPPLIER_FONFIG'",
                          },
                        ],
                        attrs: {
                          disabled: scope.row.bizType === 3,
                          type: "text",
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onAbilityVisible(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          能力配置\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "RESOURCE_SUPPLIER_DEL",
                            expression: "'RESOURCE_SUPPLIER_DEL'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.saveID(scope.row, "remove")
                          },
                        },
                      },
                      [_vm._v("\n          删除\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          "current-page": _vm.params.currentPage,
          "page-sizes": [10, 20, 40, 50, 100],
          "page-size": _vm.params.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.tipsText.dialogTitle,
            visible: _vm.deleteStrategy,
            width: "30%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteStrategy = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-text" }, [
            _vm._v("\n      " + _vm._s(_vm.tipsText.dialogText) + "\n    "),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteStrategy = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogSure(_vm.id)
                    },
                  },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.addEditTitle,
            visible: _vm.dialogFormVisible,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.formAdd, "label-position": "left" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "业务类型：",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.addEditTitle === "编辑供应商" },
                      on: { change: _vm.changeBizType },
                      model: {
                        value: _vm.formAdd.bizType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formAdd, "bizType", $$v)
                        },
                        expression: "formAdd.bizType",
                      },
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "云桌面服务", value: 1 },
                      }),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "云镜像服务", value: 2 },
                      }),
                      _c("el-option", {
                        key: 3,
                        attrs: { label: "人脸认证服务", value: 3 },
                      }),
                      _c("el-option", {
                        key: 4,
                        attrs: { label: "会议RTC服务", value: 4 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "供应商：",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.addEditTitle === "编辑供应商" },
                      on: { change: _vm.changeProductType },
                      model: {
                        value: _vm.formAdd.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formAdd, "productType", $$v)
                        },
                        expression: "formAdd.productType",
                      },
                    },
                    [
                      _vm.formAdd.bizType == 1
                        ? _c(
                            "div",
                            [
                              _c("el-option", {
                                key: 1,
                                attrs: { label: "威尔云", value: 1 },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: { label: "阿里云", value: 2 },
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: { label: "腾讯云", value: 3 },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formAdd.bizType == 2
                        ? _c(
                            "div",
                            _vm._l(_vm.tacticsResult, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm.formAdd.bizType == 3
                        ? _c(
                            "div",
                            [
                              _c("el-option", {
                                key: 7,
                                attrs: { label: "腾讯", value: 7 },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formAdd.bizType == 4
                        ? _c(
                            "div",
                            [
                              _c("el-option", {
                                key: 0,
                                attrs: { label: "即构RTC+即构IM", value: 0 },
                              }),
                              _c("el-option", {
                                key: 1,
                                attrs: { label: "网易RTC+网易IM", value: 1 },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: { label: "腾讯RTC+网易IM", value: 2 },
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: { label: "即构RTC+网易IM", value: 3 },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "合作状态：",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      key: 1,
                      attrs: { label: 1 },
                      model: {
                        value: _vm.formAdd.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formAdd, "status", $$v)
                        },
                        expression: "formAdd.status",
                      },
                    },
                    [_vm._v("合作中")]
                  ),
                  _c(
                    "el-radio",
                    {
                      key: 2,
                      attrs: { label: 2 },
                      model: {
                        value: _vm.formAdd.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formAdd, "status", $$v)
                        },
                        expression: "formAdd.status",
                      },
                    },
                    [_vm._v("终止")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "80%",
            title: "能力配置",
            visible: _vm.dialogAbilityVisible,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAbilityVisible = $event
            },
          },
        },
        [
          _c("section", { staticClass: "top" }, [
            _c("span", { staticClass: "top_name" }, [
              _vm._v(" 供应商名称：" + _vm._s(_vm.abilityConfig.name) + " "),
            ]),
            _c("span", [
              _vm._v(" 业务类型：" + _vm._s(_vm.abilityConfig.bizType) + " "),
            ]),
          ]),
          _c("section", { staticClass: "content" }, [
            _c("h4", [_vm._v("厂商控制")]),
            _c(
              "div",
              { staticClass: "content_c" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.formAbility,
                      "label-position": "top",
                      inline: true,
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _vm._v("\n            能力选项：\n            "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 1 },
                            model: {
                              value: _vm.formAbility.abilityOptions,
                              callback: function ($$v) {
                                _vm.$set(_vm.formAbility, "abilityOptions", $$v)
                              },
                              expression: "formAbility.abilityOptions",
                            },
                          },
                          [_vm._v("默认支持所有厂商")]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: 2 },
                            model: {
                              value: _vm.formAbility.abilityOptions,
                              callback: function ($$v) {
                                _vm.$set(_vm.formAbility, "abilityOptions", $$v)
                              },
                              expression: "formAbility.abilityOptions",
                            },
                          },
                          [_vm._v("默认不支持所有厂商")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "appoint" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formAbility.abilityOptions === 1
                              ? "排除厂商:"
                              : "指定厂商:"
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._l(
                      _vm.formAbility.rabbitDeviceInfoList,
                      function (item, index) {
                        return _c(
                          "section",
                          { key: index },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "40px" },
                                attrs: {
                                  label: "厂商",
                                  "label-width": _vm.formLabelWidth,
                                  rules: [
                                    {
                                      required: true,
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "240px" },
                                  attrs: {
                                    placeholder: "请输入厂商 (ex: 小米、华为)",
                                  },
                                  model: {
                                    value: item.deviceName,
                                    callback: function ($$v) {
                                      _vm.$set(item, "deviceName", $$v)
                                    },
                                    expression: "item.deviceName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-right": "40px" },
                                attrs: {
                                  label: "机型",
                                  "label-width": _vm.formLabelWidth,
                                },
                              },
                              [
                                _c("el-select", {
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    "allow-create": "",
                                    "default-first-option": "",
                                    placeholder: "请输入机型",
                                  },
                                  model: {
                                    value: item.model,
                                    callback: function ($$v) {
                                      _vm.$set(item, "model", $$v)
                                    },
                                    expression: "item.model",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "系统版本号",
                                  "label-width": _vm.formLabelWidth,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "120px",
                                      "margin-right": "20px",
                                    },
                                    attrs: { placeholder: "AndroidTV" },
                                    model: {
                                      value: item.osType,
                                      callback: function ($$v) {
                                        _vm.$set(item, "osType", $$v)
                                      },
                                      expression: "item.osType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "AndroidTV", value: 1 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Windows", value: 3 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Mac", value: 4 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "linux", value: 5 },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "120px",
                                      "margin-right": "20px",
                                    },
                                    attrs: { placeholder: "大于" },
                                    model: {
                                      value: item.osVersionLogic,
                                      callback: function ($$v) {
                                        _vm.$set(item, "osVersionLogic", $$v)
                                      },
                                      expression: "item.osVersionLogic",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "大于", value: "gt" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "小于", value: "lt" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "等于", value: "eq" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "大于等于", value: "ge" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "小于等于", value: "le" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("el-input", {
                                  attrs: { placeholder: "请输入版本号" },
                                  model: {
                                    value: item.osVersion,
                                    callback: function ($$v) {
                                      _vm.$set(item, "osVersion", $$v)
                                    },
                                    expression: "item.osVersion",
                                  },
                                }),
                                index === 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "addFirm",
                                        on: { click: _vm.addDeviceInfoList },
                                      },
                                      [_vm._v("增加厂商")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "deleteFirm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteDeviceInfoList(
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    ),
                              ],
                              1
                            ),
                            _c("br"),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
                _vm._v(
                  "\n        注：厂商与厂商之间为叠加关系，说明该供应商支持配置的厂商列表，非且和或的关系，厂商的能力控制中，满足任一条件即可（ex：能力支持\n        小米-小米电视4 + 华为智慧屏 MAX ）\n      "
                ),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "content" }, [
            _c("h4", [_vm._v("SDK版本控制")]),
            _c(
              "div",
              { staticClass: "content_c" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.form,
                      "label-position": "left",
                      inline: true,
                    },
                  },
                  _vm._l(
                    _vm.formAbility.rabbitVersionInfoList,
                    function (item, index) {
                      return _c(
                        "section",
                        { key: index },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "SDK 版本号：",
                                "label-width": _vm.formLabelWidth,
                                rules: [
                                  {
                                    required: true,
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    "margin-right": "20px",
                                  },
                                  model: {
                                    value: item.sdkVersionLogic,
                                    callback: function ($$v) {
                                      _vm.$set(item, "sdkVersionLogic", $$v)
                                    },
                                    expression: "item.sdkVersionLogic",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "大于", value: "gt" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "小于", value: "lt" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "等于", value: "eq" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "大于等于", value: "ge" },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "小于等于", value: "le" },
                                  }),
                                ],
                                1
                              ),
                              _c("el-input", {
                                attrs: { placeholder: "输入版本号 ex：3.2.1" },
                                model: {
                                  value: item.sdkVersion,
                                  callback: function ($$v) {
                                    _vm.$set(item, "sdkVersion", $$v)
                                  },
                                  expression: "item.sdkVersion",
                                },
                              }),
                              index === 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "addFirm",
                                      on: { click: _vm.addVersionInfoList },
                                    },
                                    [_vm._v("增加条件")]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass: "deleteFirm",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteVersionInfoList(
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                            ],
                            1
                          ),
                          _c("br"),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(
                  "\n        注：条件与条件之间，为且的关系，版本控制中，需满足所有条件（ex：SDK\n        <3.2.1 且 SDK >5.4.0）\n      "
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogAbilityVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveSure } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作确认",
            visible: _vm.dialogAbilitySave,
            width: "30%",
            "before-close": _vm.handleClose,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAbilitySave = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(
              "\n      保存后，配置即时生效，若配置错误，可能会导致线上无法使用，请认真核对！\n    "
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogAbilitySave = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveFormAbility },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }